<template>
  <div class="list-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="table-container">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @selection-change="selectionChange"
        @row-click="goDetail"
      >
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="save(row)">保存</el-button>
          <!-- <el-button type="primary" @click="openFilter">
            <a-icon type="filter" /> 高级筛选
          </el-button> -->
        </template>

        <template slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            v-if="menuButtonConfig.addBtn&&permission[menuButtonConfig.addBtnPermission]"
            @click.stop="handleAdd()"
            >{{ addName }}
          </el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            v-if="menuButtonConfig.addBtnTwo&&permission[menuButtonConfig.addBtnTwoPermission]"
            :disabled="disabled"
            @click.stop="handleAddTwo()"
            >{{ addNameTwo }}
          </el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            plain
            v-if="menuButtonConfig.editBtn&&permission[menuButtonConfig.editBtnPermission]"
            @click.stop="handleEdit()"
            >编辑
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            v-if="menuButtonConfig.deleteBtn&&permission[menuButtonConfig.deleteBtnPermission]"
            :disabled="disabled"
            @click.stop="handleDelete()"
            >删除
          </el-button>
          <el-button
            size="small"
            icon="el-icon-download"
            v-if="menuButtonConfig.exportBtn"
            @click="exportShow"
            >导出数据
          </el-button>
        </template>

        <!-- 
                    curd 插入的模块
                    根据传入type显示
                    linkUrl 跳转详情插槽
                 -->

        <template
          :slot="item.prop"
          slot-scope="{ row }"
          v-for="(item, index) in tableSlotConfig"
        >
          <div
            :key="index"
            class="project-name"
            :style="slotStyle"
            @click="goDetail(row)"
          >
            {{ row[item.prop] }}
          </div>
        </template>

        <!-- 过滤插槽 -->

        <template
          :slot="item.slotName"
          v-for="(item, index) in filterSlotConfig"
        >
          <!-- :bindId="searchForm[item.prop]?searchForm[item.prop]:''" -->

          <CommonSelect
            :ref="item.prop"
            :key="index"
            :searchKey="item.searchKey"
            :initParam="item.initParam"
            :bindLabel="item.bindLabel ? item.bindLabel : 'dictValue'"
            :bindKey="item.bindKey ? item.bindKey : 'dictKey'"
            :bindValue="item.bindLabel ? item.bindLabel : 'dictValue'"
            :methods="item.methods ? item.methods : 'get'"
            :dataMethod="item.dataMethod ? item.dataMethod : 'params'"
            :dataUrl="item.dataUrl"
            @handleChange="(el) => setChangeParam(el, item)"
          />
        </template>
      </avue-crud>
    </div>

    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="50%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <span>
        <div class="drawer_screen_wrapper">
          <div class="screen_header">
            <div class="screen_header_name">
              <a-icon type="filter" />
              高级筛选
            </div>
            <div class="screen_header_remarks" @click="drawer = false">
              <i class="el-icon-video-play"></i>
              收起
            </div>
          </div>
          <div class="screen_content">
            <avue-form
              :option="filterConfig"
              ref="formScreen"
              v-model="searchForm"
              @submit="filterSearch"
              @reset-change="searchResetScreen"
            >
            </avue-form>
          </div>
        </div>
      </span>
    </el-drawer>

    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import CommonSelect from "@/components/commonSelect/commonSelect";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import { downLoadTemplate } from "@/router/downLoadTem";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "TableList",
  data() {
    return {
      files: "",
      searchForm: {},
      tableData: [],
      checkUserList: [],
      checkdepartment: [],
      draw: false,
      selectionList: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      disabled: true,
    };
  },
  computed: {
    ...mapGetters(["userInfo",'permission']),
    // 插槽配置
    // 顶部过滤配置
    filterSlotConfig() {
      return this.tableConfig.column.filter((item) => {
        item.slotName = `${item.prop}Search`;
        return item.searchslot == true;
      });
    },
    // curd插槽配置
    tableSlotConfig() {
      return this.tableConfig.column.filter((item) => {
        return item.slot == true;
      });
    },
  },

  props: {
    // 表单配置
    tableConfig: {
      type: Object,
      required: true,
    },
    // 高级筛选配置
    filterConfig: {
      type: Object,
      required: true,
    },
    // 列表请求接口
    queryListApi: {
      type: Function,
      required: true,
    },
    removeApi: {
      type: Function,
      default: () => {},
    },
    // 列表详情跳转路径
    detailUrl: {
      type: String,
      default: "",
    },
    addNewUrl: {
      type: String,
      default: "",
    },
    // 导出url
    exportUrl: {
      type: String,
      default: "",
    },
    // 新增名字
    addName: {
      type: String,
      default: "新增项目",
    },
    // 自定义删除
    deleteEmit: {
      type: Boolean,
      default: false
    },
    // 新增名字
    addNameTwo: {
      type: String,
      default: "",
    },

    slotStyle: {
      type: String,
      default: "",
    },
    menuButtonConfig: {
      type: Object,
      default: () => {
        return {
          addBtn: true,
          editBtn: true,
          deleteBtn: true,
          exportBtn: true,
        };
      },
    },
  },
  components: {
    TagsCloud,
    CommonSelect,
    SelectPerson,
    SelectDepartment,
    ExportData,
  },

  watch: {
    selectionList: {
      handler(data) {
        // console.log(this.userInfo.user_id);
        let list = data.filter((item) => {
          return (
            this.userInfo.user_id == item.managerUser ||
            this.userInfo.user_id == item.assistUser
          );
        });

        this.disabled = list.length != data.length || data.length == 0;
      },
      deep: true,
    },
  },

  methods: {
    setChangeParam(data, row) {
      this.searchForm[row.searchProp] = data[row.searchkey];
    },
    openFilter() {
      this.draw = true;
    },
    save(row) {
      this.$refs.cloudtage.save(row);
    },

    cloudTages(data) {
      this.files = data;
    },

    goDetail(row) {
      this.$router.push({
        path: `${this.detailUrl}/${row.id}`,
      });
    },

    searchReset() {
      let that = this;
      this.filterSlotConfig.map((item) => {
        // console.log(that.$refs[item.prop]);
        that.$refs[item.prop][0].resetList();
      });
      this.searchForm = {};
      this.page.currentPage = 1;
      this.queryTableData();
    },

    handleAdd() {
      if (this.tableConfig.emitAddBtn) {
        this.$emit("addNew");
      } else {
        this.$router.push({
          path: `${this.addNewUrl}`,
        });
      }
    },
    handleAddTwo() {
      this.$emit("addNewTwo");
    },
    handleEdit() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        this.$router.push({
          path: `${this.detailUrl}/${data.id}`,
        });
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },

    handleDelete() {
      let self = this;
      if(this.deleteEmit) {
        this.$emit('deleteEmit', this.selectionList)
      }else {
        if (this.selectionList.length > 0) {
          this.$confirm("确定删除选择的数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              self.deleteData();
            })
            .catch(() => {
              self.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        } else {
          this.$message.error("请选择数据进行删除");
        }
      }      

    },

    exportShow() {
      this.$refs.exportData.showModel();
    },

    // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
    async deleteData() {
      let ids = this.selectionList.map((item) => {
        return item.id;
      });
      let res = await this.removeApi({ ids: ids.join(",") });
      if (res.data.code == 200) {
        this.$message.success("删除成功");
        // 刷新列表
        this.queryTableData();
      }
    },

    filterSearch(str, done) {
      this.page.currentPage = 1;
      this.queryTableData();
      this.drawer = false;
      done();
    },

    searchResetScreen() {
      this.searchForm = {};
      this.page.currentPage = 1;
      this.queryTableData();
    },

    searchChange(str, done) {
      this.queryTableData();
      done();
    },

    async queryTableData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        createDateBegin: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[0]).format("YYYY-MM-DD")
          : undefined,
        createDateEnd: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[1]).format("YYYY-MM-DD")
          : undefined,
      };
      let res = await this.queryListApi(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.records;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },

    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
        auditState: 1,
      };
      if (value.code == 1) {
        data = {
          ...data,
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          current: page.currentPage,
          size: page.pageSize,
          ...this.searchForm,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.searchForm,
        };
      }
      // console.log(this.exportUrl);
      downLoadTemplate(this.exportUrl, data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

    selectionChange(list) {
      this.selectionList = list;
    },
  },
};
</script>
<style lang="scss" scoped>
.list-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .table-container {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>